module.exports = __webpack_public_path__ + "img/Wasif.5c879c40.jpg";